// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
// Contact / update-request form: status display, monitor make/model
// dependent-field syncing, payload assembly, and submit handler. Posts
// to contactRequestEndpoint.

import { contactRequestEndpoint } from "../core/config.js";

export function createContactForm({
  contactMonitorOtherChoice,
  populateMonitorSelects,
}) {
  function setContactFormStatus(message = "", tone = "info") {
    const status = document.querySelector("[data-contact-form-status]");
    if (!status) return;
    status.textContent = message;
    status.dataset.tone = tone;
  }

  function syncContactMonitorFields(form = document.querySelector("#contactUpdateForm")) {
    if (!form) return;
    const makeSelect = form.elements?.monitorMake;
    const modelSelect = form.elements?.monitorModel;
    const isOther = makeSelect?.value === contactMonitorOtherChoice;
    form.querySelectorAll(".contact-other-monitor-field").forEach((field) => {
      field.hidden = !isOther;
    });
    if (form.elements?.monitorMakeOther) form.elements.monitorMakeOther.required = isOther;
    if (form.elements?.monitorModelOther) form.elements.monitorModelOther.required = false;
    if (modelSelect) modelSelect.disabled = !makeSelect?.value || isOther || makeSelect.disabled;
  }

  function initializeContactForm() {
    const form = document.querySelector("#contactUpdateForm");
    if (!form) return;
    populateMonitorSelects(form.elements?.monitorMake, form.elements?.monitorModel, "", "", { includeOther: true });
    syncContactMonitorFields(form);
  }

  function contactMonitorPayload(form) {
    const make = String(form.elements?.monitorMake?.value ?? "").trim();
    if (make === contactMonitorOtherChoice) {
      return {
        make: String(form.elements?.monitorMakeOther?.value ?? "").trim(),
        model: String(form.elements?.monitorModelOther?.value ?? "").trim(),
        isOther: true,
      };
    }
    return {
      make,
      model: String(form.elements?.monitorModel?.value ?? "").trim(),
      isOther: false,
    };
  }

  async function submitContactUpdateForm(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const submitButton = form.querySelector('button[type="submit"]');
    if (!form.reportValidity()) return;
    const payload = {
      name: String(form.elements?.name?.value ?? "").trim(),
      email: String(form.elements?.email?.value ?? "").trim(),
      monitor: contactMonitorPayload(form),
      comments: String(form.elements?.comments?.value ?? "").trim(),
    };
    setContactFormStatus("Sending your request...", "info");
    if (submitButton) submitButton.disabled = true;
    try {
      const response = await fetch(contactRequestEndpoint, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(result.error || "Could not send the form right now.");
      form.reset();
      initializeContactForm();
      setContactFormStatus("Thanks. Your update request was sent.", "success");
    } catch (error) {
      setContactFormStatus(error.message || "Could not send the form right now.", "error");
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  }

  return {
    setContactFormStatus,
    syncContactMonitorFields,
    initializeContactForm,
    submitContactUpdateForm,
  };
}
